import React from "react";
import "./FooterPage.styles.css";
import { FooterDesktop } from "components/Global/FooterDesktop/FooterDesktop";
import { FooterMobile } from "components/Global/FooterMobile/FooterMobile";
import MediaQuery from "react-responsive";
import { useCurrencyContext } from "hooks/useCurrencyContext";
import { updateCurrency } from "helpers/GlobalHelper";
import { getProvider } from "helpers/getProviderConfigHelper";
const FooterPage = () => {
  const [selectedCurrency, setCurrency] = useCurrencyContext();
  const { hasProvider } = getProvider();

  const changeCurrency = (val) => {
    updateCurrency(val);
    setCurrency(val);
  }

  return (
    <>
      <MediaQuery maxWidth={775}>
        <FooterMobile showEsim={!hasProvider} currency={selectedCurrency} changeCurrency={changeCurrency} />
      </MediaQuery>
      <MediaQuery minWidth={776}>
        <FooterDesktop showEsim={!hasProvider} currency={selectedCurrency} changeCurrency={changeCurrency} />
      </MediaQuery>
    </>
  );
};

export default FooterPage;
